import {
  GET_ACCTRANS,
  GET_ACCTRANS_ONE,
  GET_ACCTRANS_SUCCESS,
  GET_ACCTRANS_FAIL,
  DELETE_ACCTRANS,
  DELETE_ACCTRANS_SUCCESS,
  DELETE_ACCTRANS_FAIL,
  UPDATE_ACCTRANS,
  UPDATE_ACCTRANS_SUCCESS,
  UPDATE_ACCTRANS_FAIL,
  ADD_NEW_ACCTRANS,
  ADD_ACCTRANS_SUCCESS,
  ADD_ACCTRANS_FAIL,
  ACCTRANS_LOADING,
  ACCTRANS_RESET,
} from "./actionType";

export const resetAccTransState = (actionType) => ({
  type: ACCTRANS_RESET,
  payload: { actionType },
});

export const getAccTransSuccess = (actionType, data) => ({
  type: GET_ACCTRANS_SUCCESS,
  payload: { actionType, data },
});

export const getAccTransFail = (actionType, error) => ({
  type: GET_ACCTRANS_FAIL,
  payload: { actionType, error },
});

export const getAccTrans = data => ({
  type: GET_ACCTRANS,
  payload: data,
});

export const getAccTransOne = (data) => ({
  type: GET_ACCTRANS_ONE,
  payload: data,
});

export const getAccTransLoading = () => ({
  type: ACCTRANS_LOADING
});

export const deleteAccTrans = data => ({
  type: DELETE_ACCTRANS,
  payload: data,
});

export const deleteAccTransSuccess = data => ({
  type: DELETE_ACCTRANS_SUCCESS,
  payload: data,
});

export const deleteAccTransFail = error => ({
  type: DELETE_ACCTRANS_FAIL,
  payload: error,
});

export const updateAccTrans = data => ({
  type: UPDATE_ACCTRANS,
  payload: data,
});

export const updateAccTransFail = error => ({
  type: UPDATE_ACCTRANS_FAIL,
  payload: error,
});

export const updateAccTransSuccess = data => ({
  type: UPDATE_ACCTRANS_SUCCESS,
  payload: data,
});

export const addNewAccTrans = data => {
  return{
    type: ADD_NEW_ACCTRANS,
    payload: data,
  }
};

export const addAccTransSuccess = data => ({
  type: ADD_ACCTRANS_SUCCESS,
  payload: data,
});

export const addAccTransFail = error => ({
  type: ADD_ACCTRANS_FAIL,
  payload: error,
});